import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg';
  withIcon?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  withIcon = false,
  href,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-orange-700 text-white hover:bg-orange-800 hover:shadow-lg hover:-translate-y-0.5 focus:ring-orange-500 shadow-md',
    secondary: 'bg-stone-200 text-stone-800 hover:bg-stone-300 focus:ring-stone-400',
    outline: 'border-2 border-orange-700 text-orange-800 hover:bg-orange-50 focus:ring-orange-500'
  };
  const sizes = {
    default: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.location.href = href;
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} onClick={handleClick} {...props} data-id="element-276">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-277" />}
    </button>;
}